import React from 'react';
import styled from 'styled-components';
import { FormPublicDesignFragment } from '../../graphql/fragment/form.public.fragment';
import { Checkbox } from '@mui/material';
interface Props {
  design: FormPublicDesignFragment;
  value: string;
  children?: any;
  error?: any;
  name: string;
  id: string;
  checked: any;
  onChange: any;
}

const Field = styled(Checkbox)<{ design: FormPublicDesignFragment }>`
  &.MuiCheckbox-root {
    & .MuiSvgIcon-root {
      color: ${({ design }) => design.colors.button};
    }
  }

  &.MuiCheckbox-root:hover {
    & .MuiSvgIcon-root {
      color: ${({ design }) => design.colors.button};
    }
  }

  &.MuiCheckbox-root.Mui-checked {
    background-color: ${({ design }) => design.colors.background};
    color: ${({ design }) => design.colors.question};
    & .MuiSvgIcon-root {
      color: ${({ design }) => design.colors.button};
    }
  }

  &.MuiFormHelperText-root.Mui-error {
    color: #e42525;
  }

  & + .MuiTypography-root {
  }
`;

export const StyledCheckBox = (props: Props) => {
  return <Field {...props} />;
};
